if (!customElements.get('missence-recommendations')) {
  customElements.define(
    'missence-recommendations',
    class MissenceRecommendations extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-recommendations-track]');
        this.prevButton = this.querySelector('[data-recommendations-prev]');
        this.nextButton = this.querySelector('[data-recommendations-next]');

        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.scrollByCard = this.scrollByCard.bind(this);
        this.updateButtons = this.updateButtons.bind(this);

        this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton.addEventListener('click', () => this.scrollByCard(1));
        this.track.addEventListener('scroll', this.updateButtons, { passive: true });
        window.addEventListener('resize', this.updateButtons);
        this.updateButtons();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateButtons);
      }

      scrollByCard(direction) {
        const firstCard =
          this.track.querySelector('.missence-recommendations__item') ||
          this.track.querySelector('.missence-products-carousel__item') ||
          this.track.firstElementChild;
        if (!firstCard) return;

        const cardWidth = firstCard.getBoundingClientRect().width;
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        const itemsPerView = this.getItemsPerView();

        this.track.scrollBy({
          left: direction * ((cardWidth + gap) * itemsPerView),
          behavior: 'smooth',
        });
      }

      getItemsPerView() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const rawValue = isMobile
          ? this.dataset.itemsPerViewMobile || '1'
          : this.dataset.itemsPerViewDesktop || '4';
        const parsedValue = Number.parseInt(rawValue, 10);

        if (!Number.isFinite(parsedValue) || parsedValue < 1) return 1;
        return Math.min(parsedValue, isMobile ? 2 : 4);
      }

      updateButtons() {
        const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;
        this.prevButton.disabled = this.track.scrollLeft <= 4;
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft - 4;
      }
    }
  );
}
